import { compose, mapProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { user as userSelector } from 'ggApp/modules/auth/selectors';
import {
    storeActive as activeStoreSelector,
    currentLanguage as currentLanguageSelector,
} from 'ggApp/modules/store/selectors';

import { params as paramsSelector } from 'ggApp/modules/router/selectors';

import PreventSelfCheckout from 'ggApp/shared/modals/preventSelfCheckout/PreventSelfCheckout';

const enhance = compose(
    connect(
        createStructuredSelector({
            urlParams: paramsSelector,
            user: userSelector,
            store: activeStoreSelector,
            currentLanguage: currentLanguageSelector,
        }),
    ),
    mapProps(({ urlParams, ...rest }) => rest),
);

export default enhance(PreventSelfCheckout);
